export const maskName = (identification) => {
  if (identification) {
    identification = identification.toString();
    return `${identification.charAt(0)}****${identification.charAt(identification.length - 1)}`;
  }
  return identification;
};
